import React from 'react';
import Transactions from '.';

const TransferTransactions = () => (
  <>
    <Transactions
      title="Transfer Transactions"
      transactionType="TRANSFER"
    />
  </>
);

export default TransferTransactions;
